import { render, staticRenderFns } from "./MenuLinksList.vue?vue&type=template&id=29db96aa"
import script from "./MenuLinksList.vue?vue&type=script&lang=js"
export * from "./MenuLinksList.vue?vue&type=script&lang=js"
import style0 from "./MenuLinksList.vue?vue&type=style&index=0&id=29db96aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports